import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { TYPEFORM_COM_DEFAULT_ROOT_DOMAIN, VIDEOASK_COM_DEFAULT_ROOT_DOMAIN } from "../../constants/root-domains";
import getTranslateFunction from "../../util/translator/getTranslateFunction";
import { LANGUAGE_CODES } from "../../lib/i18n";
import React, { useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var defaultContext = {
  locale: LANGUAGE_CODES.english,
  device: 'desktop',
  sharedVariables: {
    TYPEFORM_ROOT_DOMAIN: TYPEFORM_COM_DEFAULT_ROOT_DOMAIN,
    VIDEOASK_ROOT_DOMAIN: VIDEOASK_COM_DEFAULT_ROOT_DOMAIN
  }
};
export var MainContext = /*#__PURE__*/React.createContext(defaultContext);
export var MainProvider = function MainProvider(_ref) {
  var _ref$locale = _ref.locale,
    _locale = _ref$locale === void 0 ? defaultContext.locale : _ref$locale,
    children = _ref.children,
    t = _ref.t,
    _ref$device = _ref.device,
    _device = _ref$device === void 0 ? defaultContext.device : _ref$device,
    _ref$sharedVariables = _ref.sharedVariables,
    _sharedVariables = _ref$sharedVariables === void 0 ? defaultContext.sharedVariables : _ref$sharedVariables;
  var translatorFunction = t || getTranslateFunction(_locale);
  var value = useMemo(function () {
    return {
      locale: _locale,
      t: function t(key, options) {
        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }
        return translatorFunction.apply(void 0, [key, _objectSpread(_objectSpread({}, _sharedVariables), options)].concat(args));
      },
      device: _device,
      sharedVariables: _sharedVariables
    };
  }, [_locale, _device, _sharedVariables, translatorFunction]);
  return /*#__PURE__*/_jsx(MainContext.Provider, {
    value: value,
    children: children
  });
};
MainProvider.displayName = 'MainProvider';
export var useMainContext = function useMainContext() {
  return useContext(MainContext);
};